// src/components/dialogs/ConfirmDialog.tsx
import { useTranslation } from "react-i18next";

import { ActionButton } from "@/components/common";
import {
    Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui";

interface ConfirmDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description: string;
    onConfirm: () => void;
}

export function ConfirmDialog({
    open,
    onOpenChange,
    title,
    description,
    onConfirm,
}: ConfirmDialogProps) {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <ActionButton
                        label={t("action.cancel")}
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                    />
                    <ActionButton
                        label={t("action.confirm")}
                        variant="destructive"
                        onClick={() => {
                            onConfirm();
                            onOpenChange(false);
                        }}
                    />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
} 